import { BaseOwnerEntity } from "../entity/baseOwnerEntity";

export class Device extends BaseOwnerEntity {
  id?: number;
  storeId?: number;
  name?: string;
  deviceType?: string;
  deviceCode?: string;
  serialNumber?: string;
  voipInternalId?: number;
  status?: number;
}
